/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextTemplateType
 */
export interface TextTemplateType {
    /**
     * 
     * @type {string}
     * @memberof TextTemplateType
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextTemplateType
     */
    title: string;
}

/**
 * Check if a given object implements the TextTemplateType interface.
 */
export function instanceOfTextTemplateType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function TextTemplateTypeFromJSON(json: any): TextTemplateType {
    return TextTemplateTypeFromJSONTyped(json, false);
}

export function TextTemplateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextTemplateType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
    };
}

export function TextTemplateTypeToJSON(value?: TextTemplateType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
    };
}

